import { css } from '@emotion/react';
import { themed } from '@spotnana/blocks/src/utils';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const chip_container = themed(
  ({ palette }) => css`
    display: flex;
    gap: 0.25rem;
    height: 1.5rem;
    align-items: center;
    align-self: flex-start;
    border-radius: 0.25rem;
    ${paddings.x.tight}
    ${paddings.y.superTight}
    background-color: ${palette.bg.warningSubtle};
  `,
);

export const status_icon = themed(
  ({ palette }) => css`
    color: ${palette.bg.warning};
  `,
);
